let timers = {};

export const debounce = (timer, func, timeout = 300) => {
    // return (...args) => {
    if (timers[timer]) {
        clearTimeout(timers[timer]);
    }
    timers[timer] = setTimeout(() => { func(); }, timeout);
    // };
}
